var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.downloadCSV}},[_c('b-icon-download',{staticStyle:{"margin-right":"5px"}}),_vm._v("Download Usage CSV")],1),_c('a',{attrs:{"id":"blob-link-download-csv"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }